/**
 * Canonical route paths. Prefer these over hardcoded strings so renames stay
 * grep-friendly and type-checkable. Keep in sync with `core/routes.tsx` +
 * module `*.routes.tsx` files.
 */

export const ROUTES = {
  root: '/',
  dashboard: '/dashboard',
  forbidden: '/dashboard/forbidden',
  profile: '/dashboard/profile',

  admins: '/dashboard/admins',
  avatars: '/dashboard/avatars',
  categories: '/dashboard/categories',
  customGameModes: '/dashboard/custom-game-modes',
  emotes: '/dashboard/emotes',
  individualAchievements: '/dashboard/individual-achievements',
  individualAchievementCreate: '/dashboard/individual-achievements/create',
  individualAchievementDetail: '/dashboard/individual-achievements/$id',
  individualAchievementEdit: '/dashboard/individual-achievements/$id/edit',
  teamAchievements: '/dashboard/team-achievements',
  teamAchievementCreate: '/dashboard/team-achievements/create',
  teamAchievementDetail: '/dashboard/team-achievements/$id',
  teamAchievementEdit: '/dashboard/team-achievements/$id/edit',
  leagues: '/dashboard/leagues',
  leagueDetail: '/dashboard/leagues/$id',
  leagueEdit: '/dashboard/leagues/$id/edit',
  lobbies: '/dashboard/lobbies',
  players: '/dashboard/players',
  questions: '/dashboard/questions',
  questionPools: '/dashboard/question-pools',
  questionPoolDetail: '/dashboard/question-pools/$id',
  roles: '/dashboard/roles',
  seasons: '/dashboard/seasons',
  seasonCreate: '/dashboard/seasons/create',
  seasonDetail: '/dashboard/seasons/$id',
  seasonApplications: '/dashboard/seasons/$id/applications',
  seasonEdit: '/dashboard/seasons/$id/edit',
  teams: '/dashboard/teams',
  teamLogoRequests: '/dashboard/teams/logo-requests',
  teamLogos: '/dashboard/team-logos',
  teamLogoCreate: '/dashboard/team-logos/create',
  teamTags: '/dashboard/team-tags',
  tournaments: '/dashboard/tournaments',
  tournamentDetail: '/dashboard/tournaments/$id',
  tournamentEdit: '/dashboard/tournaments/$id/edit',
  userRoles: '/dashboard/user-roles',

  auth: {
    signIn: '/',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    updateEmailVerify: '/update-email-verify',
  },
} as const

export type TRoutePath =
  | (typeof ROUTES)[keyof Omit<typeof ROUTES, 'auth'>]
  | (typeof ROUTES.auth)[keyof typeof ROUTES.auth]
